module.exports = __webpack_public_path__ + "static/img/product3.0589760.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/purple/product3.png
// module id = OPal
// module chunks = 0